/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, Paper } from '@material-ui/core';
import {
  Description as DescriptionIcon,
  Person as PersonIcon,
  Work as WorkIcon,
} from '@material-ui/icons';
import { getStatsTeam } from '@webapps/business';
import { Button, useQuery, useRouter } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../theme';
import ActionTeam from './ActionsTeam';

const {
  colors: { itemColor },
} = theme;

const TeamsCard = ({ id, label, refetch, addStudent }) => {
  const { classes, css, global, cx, theme: { spacing } } = useStyles(styles);

  const { push } = useRouter();

  const handleOpenTeam = () => {
    push(ROUTES_PATH.BUSINESS_TEAMS_DETAIL, { params: { id } });
  };

  const { data: stats = {} } = useQuery(getStatsTeam, {
    key: ['statTeam', id],
    variables: { id },
  });

  return (
    <Grid className={css({padding: "10px"})} xs={12} sm={4} lg={3} >
      <Paper className={classes.paper} >
        <div className={classes.items}>
          <div
            className={css({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            })}
          >
            <div className={global.title}>{label}</div>
            <div>
              <ActionTeam
                from="list"
                id={id}
                nbrStudent={stats?.totalMembers}
                refetch={refetch}
                addStudent={addStudent}
              />
            </div>
          </div>
          <div className={classes.cardItem} style={{ paddingTop: spacing(1.5) }}>
            <PersonIcon className={global.infoIcon} />
            <div className={global.infoText}>{stats?.totalMembers > 1 ? `${stats?.totalMembers} Apprenants` : stats?.totalMembers === 1 ? '1 Apprenant' : 'Pas d\'apprenant'} </div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon className={global.infoIcon} />
            <div className={global.infoText}>
              {stats?.pendingContracts > 1 ? `${stats?.pendingContracts} Contrats` : stats?.pendingContracts === 1 ? '1 Contrat' : 'Pas de contrat'} en attente de signature
            </div>
          </div>
          {/* <div className={classes.cardItem}>
            <EventIcon className={global.infoIcon} fontSize='24px' />
            <div className={global.infoText}>{date.Label}</div>
          </div> */}
        </div>
        <div className={classes.buttons}>
          <Button onClick={handleOpenTeam} style={{ fontWeight: 600 }} variant="outlined">
            <FormattedMessage id="business.teams.result.card.button" />
          </Button>
        </div>
      </Paper>
    </Grid>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  paper: {
    padding: spacing(2.5),
    borderRadius: 16,
    boxShadow: 'none',
  },
  cardItem: {
    display: 'flex',
    marginBottom: spacing(0.5),
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2),
  },
});

TeamsCard.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  refetch: PropTypes.func,
};

export default TeamsCard;
